import { useState, useEffect, useRef } from 'react';
import { Tabs, Form, message } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import CancellationEdit from './CancellationEdit';
import DeadLineEdit from './DeadLineEdit';
import PenaltyEdit from './PenaltyEdit';
import { savePolicyCancellation } from './../../../../../services/policy';
import Loading from './../../../../Loading';
import './index.css';

const { TabPane } = Tabs;
interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any
    cancellationDetails: void | any,
    setOperationType: void | any,
    setActiveTabKey: void | any,
    supplier: string,
    propertyId: string,
    getPoliciesData: any,
    setPoliciesData: void | any
}
const format = "MM/DD/YYYY"

const AddCancellation = (props: propsTypes) => {
    const detailRef = useRef({ resetData: () => { }, valueList: [] });
    const [activeSubCancellationTab, setActiveSubCancellationTab] = useState('Detail')
    const changeTab = (key: string) => setActiveSubCancellationTab(key)
    const [details, setDetails] = useState({ ...props.cancellationDetails })
    const [refreshCount, setRefreshCount] = useState(0)
    const [loadingFlag, setLoadingFlag] = useState(false)
    const [disableFlag, setDisableFlag] = useState(false)
    const [ dateValidation, setDateValidation] = useState(true)

    const toggleToListMode = () => {
        props.cancelEditable();
        props.setActiveTabKey('Cancellation')
    }
    const [form] = Form.useForm();

    const cancelEdit = () => {
        toggleToListMode()
        form.resetFields();
        detailRef.current.resetData();
        setRefreshCount(refreshCount + 1)
    }

    const validateForm = () => {
        form.validateFields().then(() => {
          if (!dateValidation) { 
            setDisableFlag(true)
          } else {
            setDisableFlag(false)
          }
        }).catch(err => {
            err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
        });
    }

    useEffect(validateForm, [dateValidation])

    useEffect(validateForm, 
    // eslint-disable-next-line react-hooks/exhaustive-deps     
    [])

    const saveCancellation = () => {
        form.validateFields().then(values => {
            if (!dateValidation) {
              setDisableFlag(true)
              return
            }
            setLoadingFlag(true)
            const applicalbeDays: any = detailRef.current.valueList
            const formData = {
                supplier: props.supplier,
                propertyId: props.propertyId,
                property: {
                    policies: {
                        cancelpolicy: [
                            {
                                policycode: values.policycode,
                                startdate: values?.startdate ? values?.startdate?.format(format) : '',
                                enddate: values?.enddate ? values?.enddate?.format(format) : '',
                                roomtypecode: values.roomtypecode,
                                nonrefundable: values.nonrefundable,
                                deadlinetype: values.deadlinetype,
                                timeunit: values.timeunit,
                                noofunits: values.noofunits,
                                cancelmethod: values.cancelmethod,
                                cancelTime: values.cancelTime?.format('HH:mm'),
                                chargetype: values.chargetype,
                                chargeamount: values.chargeamount ? values.chargeamount : null,
                                chargepercent: values.chargepercent ? values.chargepercent : null,
                                chargenights: values.chargenights ? values.chargenights : null,
                                currency: values.currency,
                                description: values.description,
                                taxinclusive: values.taxinclusive === 'true' ? true : (values.taxinclusive === 'false' ? false : null),
                                feeinclusive: values.feeinclusive === 'true' ? true : (values.feeinclusive === 'false' ? false : null),
                                monday: applicalbeDays[0].value,
                                tuesday: applicalbeDays[1].value,
                                wednesday: applicalbeDays[2].value,
                                thursday: applicalbeDays[3].value,
                                friday: applicalbeDays[4].value,
                                saturday: applicalbeDays[5].value,
                                sunday: applicalbeDays[6].value
                            }
                        ]
                    }
                }
            }

            savePolicyCancellation(formData).then(res => {

                if (res.result.success) {
                    setLoadingFlag(false)
                    setDetails({
                        ...formData.property.policies.cancelpolicy[0],
                        valueList: applicalbeDays,
                        start: values.startdate ? values.startdate.format(format) : '',
                        end: values.enddate ? values.enddate.format(format) : '',
                        taxinclusive: values.taxinclusive,
                        feeinclusive: values.feeinclusive,
                    })
                    toggleToListMode()
                    props.setPoliciesData({})
                    props.getPoliciesData('Cancellation')
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                    setLoadingFlag(false)
                }
                //props.setActiveTabKey('Cancellation')
            }, err => {
                setLoadingFlag(false)
                //setDetails({...formData,valueList:applicalbeDays})
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                props.cancelEditable()
                // toggleToListMode()
                // props.setPoliciesData({})
                //props.getPoliciesData('Cancellation')
                //props.setActiveTabKey('Cancellation')
            })
        }, err => {
            // message.error({
            //     content: 'Check all the fields please.',
            // });
            // toggleToListMode()
            // props.setActiveTabKey('Cancellation')
        })

    }

    return (
      <Form
        form={form}
        layout='vertical'
        className='no-padding-form'
        onValuesChange={validateForm}>
        <Tabs defaultActiveKey={activeSubCancellationTab} onChange={changeTab}>
          <TabPane tab='Detail' key='cancellationDetail' forceRender={true}>
            <CancellationEdit
              cancellationDetails={details}
              toggleToViewMode={toggleToListMode}
              setDetails={setDetails}
              setDateValidation= {(e: boolean) => {
                setDateValidation(e)
              }}
              currentForm={form}
              ref={detailRef}
            />
          </TabPane>
          <TabPane tab='Deadline' key='cancellationDeadline' forceRender={true}>
            <DeadLineEdit cancellationDetails={details} />
          </TabPane>
          <TabPane tab='Penalty' key='cancellationPenalty' forceRender={true}>
            <PenaltyEdit
              cancellationDetails={details}
              toggleToViewMode={toggleToListMode}
              setDetails={setDetails}
              currentForm={form}
            />
          </TabPane>
        </Tabs>
        <ActionButtonsBar
          onCancel={cancelEdit}
          onSave={saveCancellation}
          disabledSave={disableFlag}
          warningMsg={true}
        />
        {loadingFlag && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
            }}>
            <Loading type='large' />
          </div>
        )}
      </Form>
    )
}

export default AddCancellation;

